import React from 'react';
import { useSelector } from 'react-redux';

import { sbatGroupListSelector } from 'features/classCreation';
import RevisedClassRow from '../RevisedClassRow';
import styles from './RevisedClassesScheduleTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

function RevisedClassesScheduleTable() {
  const sbatGroups = useSelector(sbatGroupListSelector);

  return (
    <Table>
      <TableHead className={styles.head}>
        <TableRow>
          <TableCell className={styles.title}>Title</TableCell>
          <TableCell className={styles.batches}>Batches</TableCell>
          <TableCell className={styles.instructor}>
            Primary, Secondary Instructor
          </TableCell>
          <TableCell className={styles.module}>Module Name</TableCell>
          <TableCell className={styles.schedule}>Current Schedule</TableCell>
          <TableCell className={styles.schedule}>Proposed Schedule</TableCell>
          <TableCell className={styles.lock}>Lock Lecture</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {sbatGroups.map((sbatGroup) => (
          <RevisedClassRow
            key={sbatGroup.id}
            sbatGroup={sbatGroup}
          />
        ))}
      </TableBody>
    </Table>
  );
}

export default RevisedClassesScheduleTable;
